export default "__VITE_PUBLIC_ASSET__fa844265__"